// extracted by mini-css-extract-plugin
export default {"grid":"GridArticle_grid__g6YYw"};